import { getAuthState } from '../hooks/useAuth';

let auth = getAuthState()
export const validateListName = async (listName: string): Promise<object | undefined> => {
    try {
        auth = getAuthState()
        const response = await fetch(` https://f5gkmqm2yh.execute-api.us-east-1.amazonaws.com/prod/validateListName?lista_nome=${listName}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': auth.idToken
            },
        });

        const data = await response.json();
        return data.body

    } catch (error) {
        console.log(error);   
    }
};